import { decomposeColor } from '@material-ui/core';
import { Email } from '@material-ui/icons';
import { STATUS_CODES } from 'http';
import { Ratio } from 'react-bootstrap';
import HeadAdminLogin from '../components/headAdminLogin';

// Global
export const SPLASH_TIME = process.env.NODE_ENV === 'production' ? 2000 : 2000;
export const SNACKBAR_TIME =
    process.env.NODE_ENV === 'production' ? 5000 : 2000;
export const FINISH_TIME = process.env.NODE_ENV === 'production' ? 5000 : 5000;

// path
const VERSION = '/v3';
const SERVER_URL = 'https://playstartup.net';
//const SERVER_URL = 'http://3.39.177.242:5000'
const SERVER_DEV_URL = 'http://localhost:5000';
//const SERVER_DEV_URL = 'http://172.30.1.1:5000'

const SERVER =
    process.env.NODE_ENV === 'production'
        ? SERVER_URL + VERSION
        : SERVER_DEV_URL + VERSION;
const OPER = '/oper';
const ADMIN = '/admin';
const HEADADMIN = '/headadmin';
const USER = '/user';
const FUNC = '/func';
const EDU = '/edu';
const PRI = '/privacy';

const V_ADMIN = VERSION + ADMIN;
const V_USER = VERSION + USER;
const V_FUNC = VERSION + FUNC;
const VIEW = '../view';
const MAIN = '/main';
const MEMBER = '/member';
const OPERATOR = '/operator';
const SUBADMIN = '/subadmin';

// entity
const MATERIAL = '/material';
const PRODUCT = '/product';
const LICENSE = '/license';
const PURCHASE = '/purchase';
const PRODUCTION = '/production';
const SALE = '/sale';
const APPLICATION = '/application';
const SHEET = '/sheet';
const STOCK = '/stock';

// method
const ADD_PAGE = '/addPage';
const ADD = '/add';
const UPD_PAGE = '/updPage';
const UPD = '/upd';
const DEL = '/del';
const DELETE = '/delete';
const END = '/end';
const AUTH = '/auth';
const JOIN = '/join';
const LOGIN = '/login';
const LOGOUT = '/logout';
const ENTER = '/enter';
const EXIT = '/exit';
const APPROVAL = '/approval';
const DECLINE = '/decline';
const ACTION = '/action';
const FOUNDATION = '/foundation';
const STANDBY = '/standby';
const PAYBACK = '/payback';
const CONFIRM = '/confirm';
const ORDER = '/order';
const COUNT = '/count';
const EXIST = '/exist';
const ORDERSHEETLIST = '/order/sheet/list';
const ORDERSHEET = '/order/sheet';
const SEARCH = '/search';
const TYPE = '/type';
const SERVICE = '/service';
const REFUSE = '/refuse';
const NEW = '/new';
const DECOMPOSE = '/decompose';
const COMPLETE = '/complete';
const START = '/start';

// object
const APP = '/app';
const RANK = '/rank';
const CONTENTS = '/contents';
const LIST = '/list';
const PWD = '/pwd';
const ID = '/id';
const TOKEN = '/token';
const INFO = '/info';
const CLASS = '/class';
const COMPANY = '/company';
const LOAN = '/loan';
const RND = '/rnd';
const TOTAL = '/total';
const MANUAL = '/manual';
const STATUS = '/status';
const EMAIL = '/email';
const RAISE = '/raise';
const LOWER = '/lower';
const REWARD = '/reward';
const TWO = '/two';
const NUM = '/num';
const QUEST = '/quest';
const ASSET = '/asset';
const PRICE = '/price';

const REGISTER = '/register';
const UPDATE = '/update';

const DISPLAY = '/displayImage?fileName=';
const DISPLAYIMAGE = '/displayImage';
const DISPLAYFILE = '/displayFile';

export const basic = {
    version: VERSION,
    server: SERVER,
    server_url: SERVER_URL,
};

export const routes = {
    home: VERSION,
    admin: V_ADMIN,
    user: V_USER,
    func: V_FUNC,
};

export const path_value = {
    pathURL: (path: string, target: string) => {
        return path + target;
    },
    pathView: (target: string) => {
        return target.substring(1);
    },
};

export const func = {
    path: FUNC,
    version: VERSION,

    // personalInfoPolicy
    privacy: PRI,

    // Material
    material_list: MATERIAL + LIST,
    material_contents: MATERIAL + CONTENTS,
    material_addPage: MATERIAL + ADD_PAGE,
    material_add: MATERIAL + ADD,
    material_register: MATERIAL + REGISTER,
    material_upd: MATERIAL + UPD,
    material_updatePage: MATERIAL + UPD_PAGE,
    material_del: MATERIAL + DEL,

    material_update: MATERIAL + UPDATE,

    // Product
    product_list: PRODUCT + LIST,
    product_contents: PRODUCT + CONTENTS,
    product_addPage: PRODUCT + ADD_PAGE,
    product_add: PRODUCT + ADD,
    product_upd: PRODUCT + UPD,
    product_updatePage: PRODUCT + UPD_PAGE,
    product_del: PRODUCT + DEL,

    product_register: PRODUCT + REGISTER,
    product_update: PRODUCT + UPDATE,
};

export const edu = {
    path: EDU,
    class_rank_content: CLASS + RANK + CONTENTS,
};

export const auth = {
    member_auth: MEMBER + AUTH + APP,
    oper_auth: OPERATOR + AUTH + APP,
};

export const oper = {
    oper: OPER,
    path: VERSION + OPER,

    login: LOGIN,
    auth_app_info: AUTH + APP + INFO,
    auth_info: AUTH + INFO,
    update_pwd: UPDATE + PWD,
    join: JOIN,
    class_enter: CLASS + ENTER,
    delete: DELETE,

    material_order_sheet_list: MATERIAL + ORDERSHEETLIST,
    material_order_sheet_exit: MATERIAL + ORDERSHEET + EXIT,
    material_count: MATERIAL + COUNT,

    //material_sale_app_list: MATERIAL + SALE + APP + LIST,
    material_sale_app_count: MATERIAL + SALE + APP + COUNT,
    material_sale_list: MATERIAL + SALE + LIST,
    material_sale_count: MATERIAL + SALE + COUNT,
    material_sale_sheet_list: MATERIAL + SALE + SHEET + LIST,

    material_sheet_confirm: MATERIAL + SHEET + CONFIRM,
    material_sale: MATERIAL + SALE,

    product_purchase_app_list: PRODUCT + PURCHASE + APP + LIST,
    product_purchase_app_count: PRODUCT + PURCHASE + APP + COUNT,

    product_purchase_list: PRODUCT + PURCHASE + LIST,
    product_purchase_count: PRODUCT + PURCHASE + COUNT,
    product_purchase: PRODUCT + PURCHASE,
    product_purchase_app_delete: PRODUCT + PURCHASE + APP + DELETE,

    company_list: COMPANY + LIST,
    company_sheet: COMPANY + SHEET,
    company_raise: COMPANY + RAISE,
    company_lower: COMPANY + LOWER,
    company_info: COMPANY + INFO,
    company_delete: COMPANY + DELETE,
    company_info_update: COMPANY + INFO + UPDATE,
    reward: REWARD,
    reward_price: REWARD + PRICE,
};
export const admin = {
    admin: ADMIN,
    auth_app_info: AUTH + APP + INFO,
    login: LOGIN,
    join: JOIN,
    create: ADD,
    auth_class_info: AUTH + CLASS + INFO,
    class_list: CLASS + LIST,
    oper_list: OPER + LIST,
    oper_approval: OPER + APPROVAL,
    oper_delete: OPER + DELETE,
    member_list: MEMBER + LIST,
    class_delete: CLASS + DELETE,
    class_start: CLASS + START,
    class_end: CLASS + END,
    search_class: SEARCH + CLASS,
    search_class_info: SEARCH + CLASS + INFO,
    search_status: SEARCH + STATUS,
    search_member: SEARCH + MEMBER,
    update_class: UPDATE + CLASS,
    update_status: UPDATE + STATUS,
    type_update: TYPE + UPDATE,
};

export const headadmin = {
    headadmin: HEADADMIN,
    login: LOGIN,
    class_list: CLASS + LIST,
    search_class: SEARCH + CLASS,
    search_status: SEARCH + STATUS,
    update_class: UPDATE + CLASS,
    update_status: UPDATE + STATUS,
    auth_material_info: AUTH + MATERIAL + INFO,
    auth_license_info: AUTH + LICENSE + INFO,
    search_material: SEARCH + MATERIAL,
    material_list: MATERIAL + LIST,
    material_delete: MATERIAL + DELETE,
    search_license: SEARCH + LICENSE,
    license_list: LICENSE + LIST,
    license_delete: LICENSE + DELETE,
    material_add: MATERIAL + ADD,
    license_add: LICENSE + ADD,
    subadmin_list: SUBADMIN + LIST,
    subadmin_delete: SUBADMIN + DELETE,
    search_subadmin: SEARCH + SUBADMIN,
    application_list: APP + LIST,
    search_application: SEARCH + APP,
    application_delete: APP + DEL,
    application_update: APP + UPDATE,
    class_delete: CLASS + DELETE,
    search_email: SEARCH + EMAIL,
    member_list: MEMBER + LIST,
};

export const member = {
    path: VERSION + MEMBER,
    member: MEMBER,
    basic: basic,
    main: MAIN,

    join: JOIN,
    auth_app_info: AUTH + APP + INFO,
    auth_pwd_info: AUTH + PWD + INFO,
    auth_id_info: AUTH + ID + INFO,
    login: LOGIN,
    logout: LOGOUT,
    delete: DELETE,

    pwd_upd: PWD + UPD,
    token_upd: TOKEN + UPD,

    class: CLASS,
    class_enter: CLASS + ENTER,
    class_register: CLASS + REGISTER,
    class_exit: CLASS + EXIT,

    company_exist: COMPANY + EXIST,
    company_info: COMPANY + INFO,
    company_member: COMPANY + MEMBER,
    company_action: COMPANY + ACTION,
    company_foundation: COMPANY + FOUNDATION,
    company_list: COMPANY + LIST,
    company_approval: COMPANY + APPROVAL,
    company_update: COMPANY + UPDATE,
    company_decline: COMPANY + DECLINE,
    company_app: COMPANY + APP,
    company_app_list: COMPANY + APP + LIST,
    company_app_info: COMPANY + APP + INFO,
    company_app_standBy: COMPANY + APP + STANDBY,
    company_app_del: COMPANY + APP + DEL,
    company_type: COMPANY + TYPE,
    company_asset: COMPANY + ASSET,

    company_loan_list: COMPANY + LOAN + LIST,
    company_loan: COMPANY + LOAN,
    company_loan_payback: COMPANY + LOAN + PAYBACK,

    decompose_company_list: DECOMPOSE + COMPANY + LIST,

    license_list: LICENSE + LIST,
    license_rnd: LICENSE + RND,
    license_rnd_confirm: LICENSE + RND + CONFIRM,
    license_manual: LICENSE + MANUAL,

    member_material_list: MEMBER + MATERIAL + LIST,
    material_list: MATERIAL + LIST,
    material_order: MATERIAL + ORDER,
    material_count: MATERIAL + COUNT,
    material_order_service_list: MATERIAL + ORDER + SERVICE + LIST,
    material_purchase: MATERIAL + PURCHASE,
    material_sale_service_list: MATERIAL + SALE + SERVICE + LIST,
    material_sale_sheet_list: MATERIAL + SALE + SHEET + LIST,
    material_sale_sheet_exit: MATERIAL + SALE + SHEET + EXIT,
    material_sale_approval: MATERIAL + SALE + APPROVAL,
    material_sale_approval_price: MATERIAL + SALE + APPROVAL + PRICE,
    material_sale_refuse: MATERIAL + SALE + REFUSE,
    material_sale_app_list: MATERIAL + SALE + APP + LIST,
    material_loan_list: MATERIAL + LOAN + LIST,
    material_loan_status: MATERIAL + LOAN + STATUS,
    material_loan_payback: MATERIAL + LOAN + PAYBACK,
    material_loan_sheet: MATERIAL + LOAN + SHEET,
    material_payback: MATERIAL + PAYBACK,
    material_company_loan_list: MATERIAL + COMPANY + LOAN + LIST,
    material_loan_count: MATERIAL + LOAN + COUNT,
    material_loan_stock_payback: MATERIAL + LOAN + STOCK + PAYBACK,
    material_order_list: MATERIAL + ORDER + LIST,
    material_order_list_two: MATERIAL + ORDER + LIST + TWO,
    material_order_sheet_list: MATERIAL + ORDER + SHEET + LIST,

    product_order_list: PRODUCT + ORDER + LIST,

    complete_num: COMPLETE + NUM,
    quest_list: QUEST + LIST,
};

export const material = {
    list: MATERIAL + LIST,
    order: MATERIAL + ORDER,
    count: MATERIAL + COUNT,
    display: DISPLAY,

    purchase_total_list: MATERIAL + PURCHASE + TOTAL + LIST,
    purchase_total_count: MATERIAL + PURCHASE + TOTAL + COUNT,
};

export const product = {
    production_list: PRODUCT + PRODUCTION + LIST,
    sale_application: PRODUCT + SALE + APPLICATION,
    sale_application_new: PRODUCT + SALE + APPLICATION + NEW,
    sale_application_price: PRODUCT + SALE + APPLICATION + PRICE,
    sale_application_update: PRODUCT + SALE + APPLICATION + UPDATE,
    sale_company_update: PRODUCT + SALE + COMPANY + UPDATE,
    purchase_list: PRODUCT + PURCHASE + LIST,
    purchase_app_list: PRODUCT + PURCHASE + APP + LIST,
    purchase_application: PRODUCT + PURCHASE + APPLICATION,
    display_file: DISPLAYFILE + '?fileName=',
    product_delete: PRODUCT + DELETE,
    product_list: PRODUCT + LIST,
    product_purchase_count: PRODUCT + PURCHASE + COUNT,
    product_material_status: PRODUCT + MATERIAL + STATUS,

    product_decompose: PRODUCT + DECOMPOSE,
    product_decompose_list: PRODUCT + DECOMPOSE + LIST,
    product_decompose_approval: PRODUCT + DECOMPOSE + APPROVAL,
    product_decompose_count: PRODUCT + DECOMPOSE + COUNT,
    decompose_order_list: PRODUCT + DECOMPOSE + ORDER + LIST,
};

export const purchase = {
    display: DISPLAY,
    list: MATERIAL + PURCHASE + LIST,
};

export const order = {
    display: DISPLAY,
    list: MATERIAL + ORDER + LIST,
    count: MATERIAL + ORDER + COUNT,
    sheet_list: MATERIAL + ORDERSHEETLIST,
};

export const util = {
    home: VERSION,
    displayImage: DISPLAYIMAGE,
};

export const code = {
    SUCCESS_CODE: '9200',
    SUCCESS_MESSAGE: 'success',
    FAIL_CODE: '9400',
    FAIL_MESSAGE: 'fail',
    EXCEPTION_CODE: '9500',
    EXCEPTION_MESSAGE: 'exception',
    OVER_LOAN_CODE: '9450',
    OVER_LOAN_MESSAGE: 'insufficient',
    INSUFFICIENT_CODE: '9900',
    INSUFFICIENT_MESSAGE: 'insufficient',
    CLASS_NO_START_CODE: '9800',
    CLASS_NO_START_MESSAGE: 'class no start',
    CLASS_FINISH_CODE: '9700',
    CLASS_FINISH_MESSAGE: 'class finish',
    CLASS_ING_CODE: '9600',
    CLASS_ING_MESSAGE: 'class educating',
};

export const Values = {
    S3_URL: 'https://pstartup-bucket.s3.dualstack.ap-northeast-2.amazonaws.com',
    BUCKET_NAME: 'pstartup-bucket',

    SUCCESS_CODE: '9200',
    SUCCESS_MESSAGE: 'success',
    NETWORK_CODE: '9300',
    NETWORK_MESSAGE: 'network unstable',
    FAIL_CODE: '9400',
    FAIL_MESSAGE: 'fail',
    EXCEPTION_CODE: '9500',
    EXCEPTION_MESSAGE: 'exception',
    OVER_LOAN_CODE: '9450',
    OVER_LOAN_MESSAGE: 'insufficient',
    INSUFFICIENT_CODE: '9900',
    INSUFFICIENT_MESSAGE: 'insufficient',
    CLASS_NO_START_CODE: '9800',
    CLASS_NO_START_MESSAGE: 'class no start',
    CLASS_FINISH_CODE: '9700',
    CLASS_FINISH_MESSAGE: 'class finish',
    CLASS_ING_CODE: '9600',
    CLASS_ING_MESSAGE: 'class educating',
    CLASS_STOCK_INSUFFICIENT_CODE: '8800',
    CLASS_STOCK_INSUFFICIENT_MESSAGE: 'company stock insufficient',

    FIREBASE_SERVER_KEY:
        'AAAAaP_kEcw:APA91bFlTWA76-kbKp5wNzQiMlEClavQqSnc54YWz9Q1pkOGgQuSaLDxuS6LO6kIN_A6ovfd3kVt9mmkwWuuRFyh4hd9WMTSrrBJbm9j0cHyuZTYvCISiC47oJrtNU89PX8MiElUNaE_K8zZNpF8BR7K3E3IbmpR4A',
    FIREBASE_API_URL: 'https://fcm.googleapis.com/fcm/send',

    REGO_DIR: 'rego',
    MATERIAL_DIR: 'material',
    PRODUCT_DIR: 'product',
    MENUAL_DIR: 'menual',
    SALE_FINISH_CODE: '8900',
    SALE_COMPANY_UPDATE_CODE: '8600',
    SALE_FINISH_MESSAGE: 'sale finish',
    PRODUCT_DECOMPOSE_ING_CODE: '8700',
    PRODUCT_SALE_COMPLETE_CODE: '8500',

    MATERIAL_PURCHASE_TYPE: 'material_purchase',
    PRODUCT_SALE_APP_TYPE: 'product_sale_app',
    PRODUCT_SALE_TYPE: 'product_sale',
    COMPANY_ACTION: 'COMPANY_APPROVAL',
    AUTH_ACTION: 'AUTH',
    PUSH_TITLE: '플레이스타트업',

    MEMBER_DUPLICATION_LOGIN_MESSAGE: '다른기기에서 로그인되었습니다.',
    MAT_SALE_PUSH_MESSAGE: '재료 구매가 완료되었습니다.',
    PROD_SALE_APP_PUSH_MESSAGE: '제품 판매 신청이 들어왔습니다.',
    PROD_PUR_PUSH_MESSAGE: '제품 판매가 완료되었습니다.',
    COMPANY_PUSH_MESSAGE: '입사가 완료되었습니다.',
    AUTH_PUSH_MESSAGE: '인증이 완료되었습니다.',
};
